/**
 * The card payments a family makes, one per campus, as steps: "Payment 1 of 2 — Kewdale".
 *
 * A campus has its own merchant account, and one BPoint charge reaches only one of them, so a family
 * with children at two campuses enters their card twice. These steps let every screen say so the same
 * way, before, during and after each payment, so nobody pays one campus, sees a success screen and
 * closes the tab with the other campus still unpaid.
 *
 * Read from the campus breakdown the server sends (and the copy kept in the browser). Nothing here
 * decides what is charged; it only describes it.
 */

const money = (value) => Number(value || 0);

/** A campus paid by card, already paid or still to pay, in the order the server lists them. */
export const cardPaymentSteps = (breakdown = []) => (Array.isArray(breakdown) ? breakdown : [])
    .filter((row) => row && (money(row.AmountPaidFromBpoint) > 0 || (row.paymentStatus === 'paid' && money(row.alreadyPaidAmount) > 0)))
    .map((row) => {
        const paid = row.paymentStatus === 'paid';
        return {
            SessionID: row.SessionID,
            college: row.college || '',
            amount: paid ? money(row.alreadyPaidAmount || row.AmountPaidFromBpoint) : money(row.AmountPaidFromBpoint),
            paid,
            failed: row.paymentStatus === 'failed',
        };
    });

/** Which step a campus is, counting from 1, and how many there are. */
export const stepFor = (steps, sessionId) => {
    const index = steps.findIndex((step) => String(step.SessionID) === String(sessionId));
    return { number: index + 1, total: steps.length, step: index >= 0 ? steps[index] : null };
};

/** The card payments still to make. */
export const stepsStillToPay = (steps) => steps.filter((step) => !step.paid);

export const formatMoney = (value) => `$${money(value).toFixed(2)}`;
